<template>
    <div class="blockhead-item" :style="'background:' + getHex"> 
        <img :src="'/static/blockhead_' + getStats.image + '.png'">
        <div :class="{ defeated : warLogic && warLogic.defeatedPosition == 'top' }" class="stat-item top">
            <span>
                {{ getStats.top }}
            </span>
        </div>
        <div :class="{ defeated : warLogic && warLogic.defeatedPosition == 'right' }" class="stat-item right">
            <span>
                {{ getStats.right }}
            </span>  
        </div>
        <div :class="{ defeated : warLogic && warLogic.defeatedPosition == 'bottom' }" class="stat-item bottom">
            <span>
                {{ getStats.bottom }}
            </span>        
        </div>
        <div :class="{ defeated : warLogic && warLogic.defeatedPosition == 'left' }" class="stat-item left">
            <span>
                {{ getStats.left }}
            </span>  
        </div>
    </div>  
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "blockhead",
    props: [ "blockhead", "warLogic"],
    computed: {
        getHex () {
            return '#' + this.blockhead.dna.split('_')[0]
        },
        getStats () {
            const stats = this.blockhead.dna.split('_')[1];
            return { 
                top: stats.substr(0, 2),
                right: stats.substr(2, 2),
                bottom: stats.substr(4, 2),
                left: stats.substr(6, 2),
                image: stats.substr(6, 1)
            }
        }
    }
};
</script>

<style lang="less">

.blockhead-item {
    padding: 50px 0px;
    text-align: center;
    position: relative;
    border: 2px solid #222532;
    height: 220px;

    img {
        width: 40%;
    }

    .stat-item {
        position: absolute;
      
        span {
            display: block;
            margin: 0 auto;
            border: 2px solid #222532;
            background: #3c3f44;
            color: #88929b;
            font-size: 13px;
            padding: 5px 10px;
            height: 30px;
            width: 40px;
        }

        &.top {
            top: 0; left: 0;       
            text-align: center;            
            width: 100%;

            span {
                border-top: 0; 
            }
        }

        &.right {
            right: 0; top: 0;         
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                border-right: 0;
            }
        }

        &.bottom {
            bottom: 0; left: 0;
            width: 100%;

            span {
                border-bottom: 0; 
            }
        }

        &.left {
            left: 0; top: 0;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

             span {
                border-left: 0; 
            }
        }

        &.defeated span {
            color: black;
            background: red;
        }
    }
}

.blockhead-container {
    cursor: pointer;

    &.selected {
        border: 2px solid #efefef;
    }

    .blockhead-item {
        height: 100px;
        padding: 25px 0px;

        .stat-item span {
            width: 30px;
            height: auto;
            padding: 0!important;
            font-size: 11px!important;
        }
    }

}

</style>



// WEBPACK FOOTER //
// src/components/BlockHead.vue